import React from 'react';

const CloseIcon = ({ handleResetModal, siteFormat }) => {
  return (
    <div id={`feedback_modal_close_button`}>
      <button
        type='button'
        className={`close btn-tertiary ${siteFormat === 'mobile' && 'mobile-close-button'}`}
        onClick={() => {
          handleResetModal();
        }}
      >
        <svg aria-labelledby='closeIcon' height='100%' width='20px' viewBox='0 0 48.77 48.77'>
          <title id='closeIcon'>Close</title>
          <g data-name='Layer 2'>
            <g data-name='Layer 1'>
              <path d='M25.8,24.39,48.48,1.71A1,1,0,0,0,47.07.29L24.39,23,1.71.29A1,1,0,0,0,.29,1.71L23,24.39.29,47.07a1,1,0,1,0,1.41,1.41L24.39,25.8,47.07,48.48a1,1,0,0,0,1.41-1.41Z'></path>
            </g>
          </g>
        </svg>
      </button>
    </div>
  );
};

export default CloseIcon;
